export default {
  socket: () => import("/opt/buildhome/repo/layouts/Socket.vue").then(m => m.default || m),
  app: () => import("/opt/buildhome/repo/layouts/app.vue").then(m => m.default || m)
}